export const PROJECT_NAME = 'contractors'
